import { PaginacionProps } from "../global/PaginacionInterface";
import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";
import { defaultAmparo, AmparoProps } from "../recepcion/AmparoInterface";
import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../recepcion/ExhortoRecibidoInterface";
import { defaultIrregular, IrregularProps } from "../recepcion/IrregularInterface";

export const defaultBuscarLibroActuariosResponse: BuscarLibroActuariosResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroActuarios: BuscarLibroActuarios = { idAutoridad: 0, numeroReferencia: '', tipo: 1, idTipoConsecutivo: 0 };

export const defaultLibroActuarios: LibroActuariosProps = {
    idLibroActuarios:           0,
    idNotificacion:             0,
    notificacion:               '',
    idReferencia:               0,
    referencia:                 '',
    tipoAcuerdo:                '',
    subTipoAcuerdo:             '',
    lugar:                      '',
    personaNotificar:           '',
    tipoNotificacion:           '',
    formaNotificacion:          '',
    tipoParte:                  '',
    tipoTramite:                '',
    observaciones:              '',
    numeroBoleta:               '',
    expediente:                 defaultExpediente,
    amparo:                     defaultAmparo,
    exhortoRecibido:            defaultExhortoRecibido,
    irregular:                  defaultIrregular,
};


export interface LibroActuariosProps {
    idLibroActuarios:           number;
    idNotificacion:             number;
    notificacion:               string;
    numeroBoleta:               string;
    idReferencia:               number;
    referencia:                 string;
    tipoAcuerdo:                string;
    subTipoAcuerdo:             string;
    lugar:                      string;
    personaNotificar:           string;
    tipoNotificacion:           string;
    formaNotificacion:          string;
    tipoParte:                  string;
    tipoTramite:                string;
    observaciones:              string;
    expediente:                 ExpedienteProps;
    amparo:                     AmparoProps;
    exhortoRecibido:            ExhortoRecibidoProps;
    irregular:                  IrregularProps;
    fechaAutoNotificar?:        Date;
}

export interface BuscarLibroActuarios {
    idAutoridad:        number;
    numeroReferencia:   string;
    tipo:               number;
    idTipoConsecutivo?: number;
}

export interface BuscarLibroActuariosParams extends PaginacionProps, BuscarLibroActuarios { }

export interface BuscarLibroActuariosResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroActuariosProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
    tipo:               number;
    idTipoConsecutivo?: number;
}